import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { Link } from "react-router-dom";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const corailIcon = L.divIcon({
  className: "",
  html: `<div class="lbm-port-marker"></div>`,
  iconSize: [28, 28],
  iconAnchor: [14, 28],
  popupAnchor: [0, -28],
});

export default function PortsMap({ ports = [], trips = [], height = 360 }) {
  return (
    <div
      data-testid="ports-map"
      className="rounded-2xl overflow-hidden border border-brume"
      style={{ height }}
    >
      <MapContainer center={[48.7, -2.75]} zoom={10} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {ports.map((p) => {
          const portTrips = trips.filter((t) => t.port === p.name);
          return (
            <Marker key={p.id} position={[p.lat, p.lng]} icon={corailIcon}>
              <Popup>
                <div className="font-sans">
                  <div className="font-bold text-ocean text-base">{p.name}</div>
                  <div className="text-xs text-bretagne mb-2">{p.city}</div>
                  <div className="text-sm mb-2">
                    {portTrips.length > 0
                      ? `${portTrips.length} sortie${portTrips.length > 1 ? "s" : ""} disponible${portTrips.length > 1 ? "s" : ""}`
                      : "Aucune sortie pour le moment"}
                  </div>
                  <Link
                    to={`/explorer?port=${encodeURIComponent(p.name)}`}
                    data-testid={`map-port-cta-${p.id}`}
                    className="inline-block bg-ocean text-blanc font-bold text-xs px-3 py-1.5 rounded-full hover:bg-ocean/90"
                  >
                    Voir les sorties →
                  </Link>
                </div>
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>
    </div>
  );
}
